export default class Locale_UserSettings {
	UserSettings: string = "User Settings";
	AdminDoesNotAllowPersonalSettings: string = "Your administrator does not allow personal settings";
}